import { type AuthUser } from "wasp/auth";
import { getUserActivityStats, useQuery } from "wasp/client/operations";
import Breadcrumb from "../../layout/Breadcrumb";
import DefaultLayout from "../../layout/DefaultLayout";
import UserActivityChart from "./UserActivityChart";
import UsersTable from "./UsersTable";

const Users = ({ user }: { user: AuthUser }) => {
  const { data: activity } = useQuery(getUserActivityStats, {});

  return (
    <DefaultLayout user={user}>
      <Breadcrumb pageName="Users" />
      <div className="flex flex-col gap-6">
        {activity && <UserActivityChart dau={activity.dau} />}
        <UsersTable perUserActivity={activity?.perUser ?? {}} />
      </div>
    </DefaultLayout>
  );
};

export default Users;
